export const COMPLIANCE_STAFF_EMAILS = [
  "carolina@scaletowin.com",
  "megha@scaletowin.com",
  "genesis@scaletowin.com",
];

export const SORTS = [
  {
    value: "SUBMITTED_AT_DESC",
    label: "Submitted to STW at, Newest First",
  },
  {
    value: "SUBMITTED_AT_ASC",
    label: "Submitted to STW at, Oldest First",
  },
  {
    value: "NAME_ASC",
    label: "Org Name, A-Z",
  },
  {
    value: "NAME_DESC",
    label: "Org Name, Z-A",
  },
] as const;

export const TOLL_FREE_SORTS = [
  {
    value: "CREATED_AT_DESC",
    label: "Submitted to STW at, Newest First",
  },
  {
    value: "CREATED_AT_ASC",
    label: "Submitted to STW at, Oldest First",
  },
] as const;
